export interface GetFormattedDurationOptions {
  fallback?: string;
}

export const getFormattedDuration = (
  minutes: number | null | undefined,
  options: GetFormattedDurationOptions = {},
): string => {
  const { fallback = '-' } = options;

  if (minutes == null || !Number.isFinite(minutes)) {
    return fallback;
  }

  const totalMinutes = Math.max(0, Math.round(minutes));
  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;

  if (hours === 0) {
    return `${totalMinutes} min`;
  }

  const hourLabel = hours === 1 ? 'h' : 'hs';

  if (remainingMinutes === 0) {
    return `${hours} ${hourLabel}`;
  }

  return `${hours} ${hourLabel} ${remainingMinutes} min`;
};
